module.exports = __webpack_public_path__ + "img/arrow-up-big.27aa2a97.svg";